import { SummerCampaign } from '@/models/leaderboard';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';

@Component({
  name: 'CmgLeaderboardHeadbanner',
})
export default class CmgLeaderboardHeadbanner extends Vue {
  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get SoeLogo(): string {
    return this.$appStore.state.cms.images.loyalty.summerOfExtras.default;
  }

  get chevronLeftUrl(): string {
    return this.$appStore.state.cms.images.icons.chevronLeftPlain.default;
  }

  get description(): string {
    if (this.isLastChallenge && this.isChallengeComplete) {
      return 'Every milestone, done. Thanks for making this summer extra with us.'
    } else if (this.isChallengeComplete) {
      return "You crushed it. Come back next month for a fresh set of milestones to conquer";
    } else {
      return "Every purchase with an entrée unlocks a milestone. Up to two orders per day count.";
    }
  }

  get leaderboardWhiteBoxImg(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardWhiteBoxHeadBanner.default;
  }

  get currentMonthIndex(): number {
    // To assist in testing - at least a month index of 5 - June since campaigns start in June, but development occurring in May
    return Math.max(5, new Date().getMonth());
  }

  get summerCampaign(): SummerCampaign | undefined {
    return this.$appStore.state.leaderboard.summerCampaigns.find(x => x.month === this.currentMonthIndex);
  }

  get isChallengeComplete(): boolean {
    if (this.summerCampaign !== undefined) {
      return this.summerCampaign!.milestones.filter(x => !x.completed).length === 0;
    }
    return false;
  }

  get isLastChallenge(): boolean {
    // campaigns are ordered from earliest to latest in the leaderboard.service
    const lastCampaignMonth = this.$appStore.state.leaderboard.summerCampaigns.slice(-1)[0]?.month;
    return this.currentMonthIndex === lastCampaignMonth;
  }

  onClickCta() {
    this.$router.push({ name: Routes.Order, hash: '#menu' });
  }

  onClickLearnMore() {
    this.$services.ui.setModalVisibility('summerLeaderboardEducator', true, { isActivated: true});
    Vue.nextTick(() => this.$services.ui.focusDiv('.fullModal'));
  }

  onClickBack() {
    this.$router.push({ name: Routes.Rewards });
  }
}
